<template>
  <b-row>
    <b-col cols="8">

      <b-row>
        <b-card>
          <b-tabs>
            <b-tab
              id="tab-left-1"
              title="เรื่องร้องทุกข์"
            >
              <b-card
                title="ข้อมูลผู้ร้องทุกข์/ผู้ดำเนินการ"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col cols="12">
                  <BasicDetail
                    v-for="item in complainData"
                    :key="item.id"
                    :data="item.operator"
                  />
                </b-col>
              </b-card>

              <b-card
                title="ผู้มอบอำนาจ"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col
                  cols="12"
                  class=""
                >
                  <BasicDetail
                    v-for="item in complainData"
                    :key="item.id"
                    :data="item.attorney"
                  />
                </b-col>
              </b-card>

              <b-card
                title="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col cols="12">
                  <Company
                    v-for="item in complainData"
                    :key="item.id"
                    :company="item.company"
                    :edit="false"
                  />
                </b-col>
              </b-card>

              <b-card
                title="รายละเอียดเรื่องร้องทุกข์"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col cols="12">
                  <b-form-textarea
                    v-for="item in complainData"
                    :key="item.id"
                    v-model="item.complainDetail"
                    readonly
                    rows="3"
                  />
                </b-col>

                <b-col cols="12">
                  <ComplainChecklist
                    :complain="complainData"
                    :disabled="true"
                  />
                </b-col>
                <b-card title="ท่านมีความประสงค์เข้าไกล่เกลี่ยในรูปแบบออนไลน์หรือไม่">
                  <b-col cols="12">
                    <div class="demo-inline-spacing">
                      <b-form-radio
                        v-model="DMediateSelected"
                        name="rdoDMediateSelected"
                        value="1"
                        class="custom-control-info"
                        :disabled="true"
                      >
                        ต้องการ
                      </b-form-radio>
                      <b-form-radio
                        v-model="DMediateSelected"
                        name="rdoDMediateSelected"
                        value="0"
                        class="custom-control-info"
                        :disabled="true"
                      >
                        ไม่ต้องการ
                      </b-form-radio>
                    </div>
                  </b-col>
                </b-card>
              </b-card>
            </b-tab>
            <TabAttachFiles />
          </b-tabs>
        </b-card>
      </b-row>

    </b-col>
    <RightTab />
  </b-row>

</template>

<script>
import {
  BRow, BCol, BFormTextarea, BCard, BFormRadio, BTab, BTabs,
} from 'bootstrap-vue'
import ComplainChecklist from '../components/ComplainChecklist.vue'
import Company from '../components/Company.vue'
import BasicDetail from '../components/BasicDetail.vue'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import RightTab from './components/RightTab.vue'
import TabAttachFiles from './components/TabAttachFiles.vue'

export default {
  components: {
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    ComplainChecklist,
    Company,
    BasicDetail,
    BCardActions,
    RightTab,
    TabAttachFiles,
  },
  data() {
    const complainDatas = [
      {
        id: '1',
        operator: [{
          personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        },
        {
          personalId: '123456789013', fullname: 'นาย ทดสอบ1 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{ companyId: '123', companyName: 'บริษัท AA', companyDetail: 'ตั้งอยู่ที่ไหน??' }],
        complainDetail: 'ทดสอบร้องเรียน VUE',
        complainMainType: [1, 9],
        complainSubType: [1, 2, 3],
        complainCause: [152, 159],
        complainPlace: [1, 3, 5],
        complainMotive: [1, 5],
        complainPayment: [1, 3],
        isDmediate: false,
      },
      {
        id: '2',
        operator: [{
          personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{ companyId: '123', companyDetail: 'บริษัท BB' }],
        complainDetail: 'ทดสอบร้องเรียน VUE',
        complainMainType: [1, 4],
        complainSubType: [2, 3],
        complainCause: [2, 3, 5],
        complainPlace: [3, 5],
        complainMotive: [1, 3],
        complainPayment: [1, 5],
        isDmediate: true,
      },
    ]

    return {
      DMediateSelected: '0',
      complainId: null,
      complainList: complainDatas,
      complainData: [{}],

    }
  },
  created() {
    const { id } = this.$route.query
    this.complainId = id
    const res = this.$route.query == null ? [] : this.complainList.filter(d => { if (d.id == id) return d })
    this.complainData = res

    // console.log(this.complainId)
    // console.log(this.complainData)
  },

}
</script>

 <style lang="scss" >

</style>
